import './assets/main.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useToastStore } from '@/stores/toast';
import { useAuthStore } from '@/stores/auth';
import { i18n } from './utils/i18n';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
import './utils/icons';
import type { Stimulsoft as StimulsoftNS } from 'stimulsoft-reports-js';
//import * as Sentry from '@sentry/vue';

const Stimulsoft = (window as any).Stimulsoft as typeof StimulsoftNS;

Stimulsoft.Base.StiLicense.Key =
  '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHm5y5pLNXSbkstTpxbUcKlVS0jtLeF4drSN/UTl3MANfQKZyX' +
  'qIdW37Fzua4m2IOZ9wRzPjy+qN5/Emf2d/dS/t2N5ZQB5egoK5dsEaKZWb5uMTrMp4BzF4TnwIs/Z/argw98BOqHTu' +
  'sxalLDwhuW5UmWWlLAkvEcoFeYNSEU2Wa5TlYx11RkLzKhfAXcap9k1f6SSgLbp5IcbMuUgPdjzxme3K/oveJ3Otew' +
  'segU14CN21d0YMTtEt741v0GRpyLnhEZX1yQouqmYx2eX1+TcU1AMehVduqJsJibZ418RgHRquhziIHyp5AcNprGwd' +
  'WKH4o4yIffup9Ah/DaILHFjk1ds4Zo7V6Fu/1PKanhboqDD8GTD+BcgrEOqROSLGZ6V8rHstuxAxsRz3bYb7JP04ru' +
  'uJgUJPAyoWQS56cQqBFBpn6CqyMJ32u12v15NPht9kNHrUtv0nUrlVG7mjP8eks0pMj+traX1RvxZLTREOwZl1yZ4u' +
  'wlABBBa0Qwjv+u7yMHcX/F6CA6AqaWE4TlJwq01PF5XAeTyra3wI2Y5KYR3HmI0lJjR6bybCvACGqls=';

const app = createApp(App);
app.use(createPinia());
app.use(i18n);
app.use(router);
app.use(PerfectScrollbarPlugin);

// TODO Enable Sentry when ready
// if (import.meta.env.VITE_APP_ENV === 'Production') {
//   Sentry.init({
//     app,
//     dsn: 'https://8c0d6e223dde1118b7a903a8a41f84f9@o4509870092386304.ingest.de.sentry.io/4509870093893712',
//     sendDefaultPii: true,
//     integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
//     tracesSampleRate: 1.0,
//     tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
//     replaysSessionSampleRate: 0.01,
//     replaysOnErrorSampleRate: 1.0,
//     enableLogs: true,
//     ignoreErrors: [
//       /\$setup\./,
//       /\$ctx\./,
//       /_ctx\./,
//       /ResizeObserver/,
//       /Script error/,
//       /Network request failed/,
//       /Loading chunk/,
//       /ChunkLoadError/,
//     ],
//   });
// }

const toastStore = useToastStore();
const { clearActiveRequestCounter } = useAuthStore();

app.config.errorHandler = (err: any /*, instance: any, info: any*/) => {
  console.error('An error occurred:', err);

  // TODO Enable Sentry when ready
  // if (import.meta.env.VITE_APP_ENV === 'Production') {
  //   Sentry.captureException(err, {
  //     contexts: {
  //       vue: {
  //         componentName: instance?.$options?.name || 'Unknown',
  //         errorInfo: info,
  //       },
  //     },
  //   });
  // }

  toastStore.error({ text: err.message ? err.message : err });
  clearActiveRequestCounter();
};

window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
  console.error('Unhandled promise rejection:', event.reason);
});

app.mount('#app');
